import { Navigate, Route, Routes } from 'react-router-dom';
import { useMe } from './api/hooks';
import { authDisabled, isUnauthorized } from './api/http';
import { LoginScreen, Splash } from './app/AuthGate';
import { Shell } from './app/Shell';
import { DashboardPage } from './features/dashboard/DashboardPage';
import { BotAuthPage, BotChannelsPage, BotLayout, BotOverviewPage } from './features/bots/BotPages';
import { ChannelLayout } from './features/channels/ChannelLayout';
import { ChannelApiKeysPage, FeaturesPage, ScopesPage } from './features/channels/ChannelPages';
import { SubscriptionsPage } from './features/subscriptions/SubscriptionsPage';
import { ActivityPage, EventSubPage } from './features/activity/ActivityPage';
import { BotEnrollmentsPage } from './features/enrollments/BotEnrollmentsPage';
import { ChannelHelixPage } from './features/helix/ChannelHelixPage';

export function App(): JSX.Element {
  const me = useMe();
  if (me.isPending) return <Splash>Vérification de la session…</Splash>;
  if (me.isError && !authDisabled(me.error)) {
    return <LoginScreen reason={isUnauthorized(me.error) ? undefined : me.error.message} />;
  }
  if (me.data && (!me.data.authenticated || !me.data.isAdmin)) {
    return <LoginScreen />;
  }
  return (
    <Routes>
      <Route element={<Shell user={me.data?.user} />}>
        <Route index element={<DashboardPage />} />
        <Route path="bots/:botId" element={<BotLayout />}>
          <Route index element={<BotOverviewPage />} />
          <Route path="channels" element={<BotChannelsPage />} />
          <Route path="enrollments" element={<BotEnrollmentsPage />} />
          <Route path="authorization" element={<BotAuthPage />} />
          <Route path="activity" element={<ActivityPage />} />
        </Route>
        <Route path="bots/:botId/channels/:channelId" element={<ChannelLayout />}>
          <Route index element={<SubscriptionsPage />} />
          <Route path="helix" element={<ChannelHelixPage />} />
          <Route path="scopes" element={<ScopesPage />} />
          <Route path="features" element={<FeaturesPage />} />
          <Route path="api-keys" element={<ChannelApiKeysPage />} />
          <Route path="activity" element={<ActivityPage />} />
        </Route>
        <Route path="eventsub" element={<EventSubPage />} />
        <Route path="activity" element={<ActivityPage />} />
        <Route path="helix" element={<Navigate to="/" replace />} />
        <Route path="enrollments" element={<Navigate to="/" replace />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
